/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';
import { oneOffPaymentNoticeDeleteRequestSchema } from './oneOffPaymentNoticeDeleteRequestSchema.ts';
import { oneOffPaymentNoticeDeleteResponseSchema } from './oneOffPaymentNoticeDeleteResponseSchema.ts';

/**
 * @description 200 response
 */
export const deleteOneOffPaymentNotice200Schema = z.lazy(() => oneOffPaymentNoticeDeleteResponseSchema);

/**
 * @description 505 response
 */
export const deleteOneOffPaymentNotice505Schema = z.any();

export const deleteOneOffPaymentNoticeMutationRequestSchema = z.lazy(() => oneOffPaymentNoticeDeleteRequestSchema);

export const deleteOneOffPaymentNoticeMutationResponseSchema = z.lazy(() => deleteOneOffPaymentNotice200Schema);
